import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
type InvestorSearchMainPanelProps = {
  children: ReactNode | ReactNode[];
};
export const InvestorSearchMainPanel = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.children) {
    t0 = <VStack align="stretch" alignSelf="stretch" gap={0} height="full" justify="stretch" justifySelf="stretch" width="full">{props.children}</VStack>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};